/** Default stroke color for performance target curves and legend swatch. */
export const DEFAULT_PERFORMANCE_TARGET_COLOR = '#00ff7f';

/** Preset palette for the target color selector (includes default green first). */
export const PERFORMANCE_TARGET_COLOR_OPTIONS: readonly string[] = [
  '#00ff7f',
  '#FF0000',
  '#0000FF',
  '#008000',
  '#FFA500',
  '#800080',
  '#808080',
  '#000000',
  '#FFFF00',
  '#00FFFF',
  '#FF00FF',
  '#A52A2A',
  '#4682B4',
  '#32CD32',
  '#FF4500',
  '#9400D3',
  '#C0C0C0',
  '#2F4F4F',
  '#FFD700',
  '#20B2AA',
  '#DC143C',
  '#8B4513',
  '#1E90FF',
  '#228B22',
  '#FF6347',
] as const;

export function normalizePerformanceTargetColor(color: string | null | undefined): string {
  if (!color || typeof color !== 'string') return DEFAULT_PERFORMANCE_TARGET_COLOR;
  const trimmed = color.trim();
  if (!trimmed) return DEFAULT_PERFORMANCE_TARGET_COLOR;
  return trimmed;
}
